export default {
  name: 'LFooter',
  data() {
    return {
      msg: 'footer',
      link: [{
        title: '支持与服务',
        children: [{
          name: '开发者文档',
          url: 'http://showdoc.cosmoplat.com'
        }, {
          name: '开源社区',
          url: 'https://openlab.cosmoplat.com/#/index'
        }, {
          name: '新手入门',
          url: 'https://www.cosmoplat.com/help/detail/105/303'
        }, {
          name: '文档中心',
          url: 'https://www.cosmoplat.com/help'
        }, {
          name: '学习培训',
          url: 'https://edu.cosmoplat.com/'
        }, {
          name: '建议反馈',
          url: 'https://www.cosmoplat.com/evaluate/message?websiteId=1&webplat=COSMOPlat%E9%97%A8%E6%88%B7'
        }, {
          name: '供需发布',
          url: 'https://www.cosmoplat.com/needLobby'
        }]
      }, {
        title: '相关链接',
        children: [{
          name: '卡奥斯工业互联网平台',
          url: 'https://www.cosmoplat.com/'
        }, {
          name: '卡奥斯工赋青岛',
          url: 'https://www.gongfuqd.com/?source=cosmoplat#/'
        }, {
          name: '海云智造',
          url: 'https://im-portal.s.cosmoplat.com/'
        }, {
          name: '海智化云',
          url: 'https://chem.cosmoplat.com/home'
        }, {
          name: '海模智云',
          url: 'https://hmzy.cosmoplat.com/#/home'
        }]
      }],
      // 合字B2-20200094 合字B2-20200096 鲁ICP备2021010660号 鲁公网安备37021202001456号
      bottomLink: [{
        name: '合字B2-20200094',
        url: 'https://tsm.miit.gov.cn/dxxzsp/'
      }, {
        name: '合字B2-20200096',
        url: 'https://tsm.miit.gov.cn/dxxzsp/'
      }, {
        name: '鲁ICP备2021010660号',
        // url: 'https://beian.miit.gov.cn/'
        url: 'https://beian.miit.gov.cn/'
      }, {
        name: '鲁公网安备37021202001456号',
        // url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702004474'
        url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021202001456'
      }]
    };
  },
  methods: {
    handleGo(url) {
      window.open(url);
    }
  }
};